import React, { Component } from 'react'
import { StaticBox, FlowTable } from 'components/basic'

class LeaseInfo extends Component {
  constructor (props) {
    super(props)
    this.state = {
      leaseInfo: null,
      error: false,
      loading: true
    }
  }
  componentDidMount () {
    this.setState({loading: true})
    this.setData(this.props.leaseInfo, this.props.errors)
  }
  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return
    this.setState({loading: true, leaseInfo: null})
    this.setData(props.leaseInfo, props.errors)
  }
  async setData (leaseInfo, err) {
    if (!leaseInfo && !err.error) return
    if (err.error) return this.setState({error: err, loading: false})
    this.setState({ leaseInfo: leaseInfo, loading: false, error: false })
  }
  reload () {
    this.setState({loading: true})
    this.props.reload()
  }
  render () {
    return (
      <StaticBox dataLoading={this.state.loading} title='Lease Info' icon='info' buttons={[{ icon: 'fa-refresh', event: () => this.reload() }]}>
        {this.state.leaseInfo &&
          <pre className='no-overflow mt-10 no-padding'>
            <FlowTable noClass data={this.state.leaseInfo.map(lease => [
              lease.lease,
              lease.mac,
              lease.serviceType,
              lease.start,
              lease.end
            ])}>
              <tr>
                <th>Lease</th>
                <th>Mac</th>
                <th>Service Type</th>
                <th>Start</th>
                <th>End</th>
              </tr>
            </FlowTable>
          </pre>
        }
        {this.state.error &&
          <pre className='table-pre mt-10'>
            <div className='error-wrapper'>
              <span><i className='fa fa-fw fa-exclamation-triangle' /> <b>Error fetching Lease Info {this.state.error.cause ? '- ' + this.state.error.cause : ''}</b></span>
            </div>
          </pre>
        }
      </StaticBox>
    )
  }
}
export default LeaseInfo



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/2.4/troubleshooting/LeaseInfo.js